module.exports = __webpack_public_path__ + "img/24.02ad68d3.png";